import {DDR} from './ddr.class';

export class DDRPregnant1930Strategy extends DDR {
  constructor() {
    super([770, 5, 15, 90, 85, 1.4, 1.4, 18, 1.9, 600, 2.6, 6, 30, 450, 1000, 30, 1000, 3, 220, 27, 350, 2, 700, 60, 11]);
  }
}
